import React, { useContext, useEffect, useState } from "react";
import { GlobalSubheader } from "../../components/subHeader/GlobalSubheader";
import { DefaultPageContainer } from "../../components/layoutContainer/styles/LayoutContainer";
import { CircularProgress, Grid, IconButton } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import DeviceInfo from "./components/DeviceInfo";
import DeviceConnect from "./components/DeviceConnect";
import {
  addNewInstance,
  getEntityInstances,
  updatePhoneUsage,
} from "../../repositories/portal_api/ConectaZap";
import { GlobalContext } from "../../contexts/GlobalContext";
import { notify } from "../../utils/notify";
import { DialogConfirm } from "../customerManagements/children/DialogConfirm";
import { socket } from "./socket/socket";
import Loading from "../../components/basics/Loading";
import { getEntitySystems } from "../../repositories/portal_api/Systems";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ConectaZapPage = ({ ...props }) => {
  const [instancesConectaZap, setInstancesConectaZap] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddInstance, setShowAddInstanceDialog] = useState(false);
  const [chatAlreadySelected, setChatAlreadySelected] = useState(false);
  const [notificationAlreadySelected, setNotificationAlreadySelected] =
    useState(false);
  const [loadingPage, setLoadingPage] = useState(false);

  const { companyUser } = useContext(GlobalContext);

  const { replace } = useHistory();
  useEffect(() => {
    // TODO: GET CONECTAZAP INSTANCES
    initialSetup();
    // eslint-disable-next-line
  }, []);

  async function initialSetup() {
    setLoading(true);

    const responseSystems = await getEntitySystems();
    let hasConectaZap = false;

    if (responseSystems?.success) {
      responseSystems?.data.forEach((system) => {
        if (system?.system_id === 20 && system?.status === "A") {
          hasConectaZap = true;
        }
      });
    }

    if (!hasConectaZap) {
      notify("Você não possui o produto ConectaZap", true, "error");
      setLoading(false);
      replace("/dashboard/view");
      return;
    }

    let instances = await getInstances();

    if (instances?.length === 0) {
      instances = await addInstance();
    }

    if (instances.length > 0) {
      instances.forEach((instance) => {
        if (instance?.flags?.chat) {
          setChatAlreadySelected(true);
        }
        if (instance?.flags?.notifications) {
          setNotificationAlreadySelected(true);
        }
      });
    }

    setInstancesConectaZap(instances);

    setLoading(false);
  }

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Conectado ao servidor!");
    });

    socket.on("disconnect", () => {
      console.log("Desconectado do servidor");
    });

    const listTopics = instancesConectaZap.map((instance) => {
      return {
        topicName: `cnpj/${companyUser.document}/instance/${instance.id}/on-connect`,
        instanceId: instance.id,
      };
    });

    listTopics.forEach((topic) => {
      socket.on(topic.topicName, (value) => {
        const eventJson = JSON.parse(value);
        updateInstanceConnection(topic.instanceId, eventJson?.status);
      });
    });

    socket.connect();

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      listTopics.forEach((topic) => {
        socket.off(topic.topicName);
      });
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, [instancesConectaZap]);

  function updateInstanceConnection(instanceId, status) {
    if (status === "deleted") {
      let copyIntances = [...instancesConectaZap];

      copyIntances = copyIntances.filter((instance) => {
        return instance.id !== instanceId;
      });

      setInstancesConectaZap(copyIntances);
    } else {
      let copyIntances = [...instancesConectaZap];

      copyIntances.map((instance) => {
        if (instance.id === instanceId) {
          instance.status = status ? "connected" : "disconnected";
        }

        return instance;
      });

      setInstancesConectaZap(copyIntances);
    }
  }

  const getInstances = async () => {
    try {
      const response = await getEntityInstances(companyUser.document);

      if (response?.success) {
        let instances = [];

        if (response?.data?.data?.length > 0) {
          response?.data?.data.forEach((instance) => {
            let status = "waiting";

            if (instance?.status === 0 && instance?.phoneNumber) {
              status = "disconnected";
            } else if (instance.status === 1) {
              status = "connected";
            }

            if (instance?.flags?.chat) {
              setChatAlreadySelected(true);
            }

            if (instance?.flags?.notifications) {
              setNotificationAlreadySelected(true);
            }

            instances.push({
              id: instance.id,
              name: instance.instanceName,
              status: status,
              number: instance.phoneNumber,
              flags: instance.flags,
              phoneNumber: instance?.phoneNumber,
              phoneNumberId: instance?.phoneNumberId,
            });
          });
        }
        // setInstancesConectaZap(instances);
        return instances;
      } else {
        throw new Error("Erro ao buscar instâncias");
      }
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  async function addInstance() {
    try {
      setLoading(true);
      const response = await addNewInstance(companyUser.document);

      if (response.success) {
        notify("Instância adicionada com sucesso", true, "success");
        const instances = await getInstances();
        return instances;
      } else {
        console.log(response);
        if (response.code === 403) {
          notify("Limite de contas atingido", true, "warning");
        } else {
          throw new Error("Erro ao adicionar conta", true, "error");
        }
      }
    } catch (error) {
      console.log(error);
      notify("Erro ao adicionar conta", true, "error");
    } finally {
      setLoading(false);
    }
  }

  async function updateInstance({ instance, value, type }) {
    let copyIntances = [...instancesConectaZap];

    setLoadingPage(true);

    if (type === "chat") {
      setChatAlreadySelected(value);
    }

    if (type === "notifications") {
      setNotificationAlreadySelected(value);
    }

    const response = await updatePhoneUsage(
      companyUser.document,
      instance.phoneNumberId,
      type,
      value
    );

    if (response?.success) {
      copyIntances.map((instanceCopy) => {
        if (instanceCopy.id === instance.id) {
          if (type === "chat") {
            instanceCopy.flags.chat = value;
          } else if (type === "notifications") {
            instanceCopy.flags.notifications = value;
          }
        }

        return instanceCopy;
      });

      setInstancesConectaZap(copyIntances);
    } else {
      if (type === "chat") {
        setChatAlreadySelected(!value);
      }

      if (type === "notifications") {
        setNotificationAlreadySelected(!value);
      }

      notify("Erro ao atualizar uso do telefone", true, "error");
    }

    setLoadingPage(false);
  }

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <Loading open={loadingPage}></Loading>
      <GlobalSubheader title={"ConectaZap"} titleLocation={"/conecta-zap"} />
      <DefaultPageContainer>
        <div
          style={{
            background: "#fff",
            border: "1px solid #E0E0E0",
            borderRadius: 15,
            padding: 16,
          }}
        >
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingBottom: 8,
                  borderBottom: "1px solid #CECFD0",
                }}
              >
                <div style={{ fontSize: 18, fontWeight: 800 }}>
                  Contas Whatsapp
                </div>
                <IconButton
                  size="small"
                  style={{
                    background: "#0036B3",
                    color: "#fff",
                  }}
                  onClick={() => {
                    setShowAddInstanceDialog(true);
                  }}
                >
                  <Add></Add>
                </IconButton>
              </div>

              {instancesConectaZap?.length > 0 ? (
                instancesConectaZap.map((instance) => {
                  return (
                    <Grid
                      container
                      style={{
                        marginTop: 16,
                        background: "#fff",
                        border: "1px solid #E0E0E0",
                        borderRadius: 15,
                        padding: 16,
                      }}
                    >
                      <>
                        <Grid item xs={12} sm={12} md={6}>
                          <DeviceInfo
                            instance={instance}
                            updateInstance={updateInstance}
                            alreadySelectedChat={chatAlreadySelected}
                            alreadySelectedNotification={
                              notificationAlreadySelected
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <DeviceConnect
                            instance={instance}
                            updateInstanceConnection={updateInstanceConnection}
                            setLoadingPage={setLoadingPage}
                          />
                        </Grid>
                      </>
                    </Grid>
                  );
                })
              ) : (
                <div> Nenhuma instância cadastrada</div>
              )}
            </>
          )}
        </div>
      </DefaultPageContainer>

      <DialogConfirm
        title={"Adicionar Conta"}
        description={
          "Você deseja adicionar uma nova conta para utilização do ConectaZap?"
        }
        handleClose={() => {
          setShowAddInstanceDialog(false);
        }}
        handleConfirm={async () => {
          setShowAddInstanceDialog(false);
          await addInstance();
        }}
        open={showAddInstance}
      ></DialogConfirm>
    </div>
  );
};

export default ConectaZapPage;
